/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAudioPresignedURLResponseContent
 */
export interface GetAudioPresignedURLResponseContent {
    /**
     * 
     * @type {string}
     * @memberof GetAudioPresignedURLResponseContent
     */
    url?: string;
}


/**
 * Check if a given object implements the GetAudioPresignedURLResponseContent interface.
 */
export function instanceOfGetAudioPresignedURLResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAudioPresignedURLResponseContentFromJSON(json: any): GetAudioPresignedURLResponseContent {
    return GetAudioPresignedURLResponseContentFromJSONTyped(json, false);
}

export function GetAudioPresignedURLResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAudioPresignedURLResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function GetAudioPresignedURLResponseContentToJSON(value?: GetAudioPresignedURLResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

